import React, { useState, useEffect } from 'react';
import { AlertTriangle, Info, XCircle, X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const MaintenanceBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetchBannerSettings();
    // Check for updates every 60 seconds
    const interval = setInterval(fetchBannerSettings, 60000);
    return () => clearInterval(interval);
  }, []);

  const fetchBannerSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/maintenance/banner`);
      if (response.data.enabled) {
        setBanner(response.data);
        setDismissed(false); // Show again if re-enabled
      } else {
        setBanner(null);
      }
    } catch (err) {
      // Silently fail - don't show banner if we can't fetch settings
      console.error('Failed to fetch maintenance banner:', err);
    }
  };

  if (!banner || !banner.enabled || dismissed) {
    return null;
  }

  const getTypeStyles = () => {
    switch (banner.type) {
      case 'critical':
        return {
          bg: 'bg-red-600 dark:bg-red-700',
          icon: <XCircle className="w-5 h-5" />,
          text: 'text-white'
        };
      case 'warning':
        return {
          bg: 'bg-amber-500 dark:bg-amber-600',
          icon: <AlertTriangle className="w-5 h-5" />,
          text: 'text-white'
        };
      default: // info
        return {
          bg: 'bg-blue-600 dark:bg-blue-700',
          icon: <Info className="w-5 h-5" />,
          text: 'text-white'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div className={`${styles.bg} ${styles.text} px-4 py-3 relative`}>
      <div className="container mx-auto flex items-center justify-center gap-3">
        {styles.icon}
        <p className="text-sm font-medium text-center">
          {banner.message}
        </p>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
